import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Portfolio({ data }) {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const projects = data?.projects.map((project) => {
    const projectImage = `${process.env.PUBLIC_URL}/images/portfolio/${project.image}`;
    return (
      <div key={project.title} className="columns portfolio-item" data-aos="fade-up">
        <div className="item-wrap">
          <a href={project.url} title={project.title}>
            <img alt={project.title} src={projectImage} />
            <div className="overlay">
              <div className="portfolio-item-meta">
                <h5>{project.title}</h5>
                <p>{project.category}</p>
              </div>
            </div>
            <div className="link-icon"><i className="fa fa-link"></i></div>
          </a>
        </div>
      </div>
    );
  });

  return (
    <section id="portfolio">
      <div className="row">
        <div className="twelve columns collapsed">
          <h1>Check Out Some of My Works.</h1>
          <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
            {projects}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
